import { render, staticRenderFns } from "./RecommendedItems.vue?vue&type=template&id=e400135c&scoped=true&"
import script from "./RecommendedItems.vue?vue&type=script&lang=js&"
export * from "./RecommendedItems.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedItems.vue?vue&type=style&index=0&id=e400135c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e400135c",
  null
  
)

export default component.exports